import React from "react";
import "./index.css";
import { Icon } from "semantic-ui-react";

const PromotedLabel = ({ className = "" }) => (
  <div className={`promoted-label ${className}`}>
    Promoted
    <Icon name="external" />
  </div>
);

export default PromotedLabel;



// WEBPACK FOOTER //
// ./src/components/PostsList/components/AdCard/Components/PromotedLabel/index.js